var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageUsersMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.875C15.364 16.875 16.875 15.364 16.875 13.5C16.875 11.636 15.364 10.125 13.5 10.125C11.636 10.125 10.125 11.636 10.125 13.5C10.125 15.364 11.636 16.875 13.5 16.875Z",
    stroke: "#AEAAB9",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0752 11.6948L20.8403 8.7129L22.5 6.75L20.25 4.5L18.2978 6.16832L15.2525 4.91596L14.5522 2.25H12.3536L11.6427 4.95127L8.66746 6.20546L6.75 4.5L4.5 6.75L6.13504 8.76246L4.91906 11.7521L2.25 12.375V14.625L4.95125 15.3624L6.20522 18.3372L4.5 20.25L6.75 22.5L8.76506 20.8578L11.6966 22.0638L12.375 24.75H14.625L15.3051 22.0648L18.287 20.8299C18.784 21.1852 20.25 22.5 20.25 22.5L22.5 20.25L20.8304 18.2806L22.0656 15.2977L24.7499 14.5993L24.75 12.375L22.0752 11.6948Z",
    stroke: "#AEAAB9",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsersMenuIcon);
export default __webpack_public_path__ + "static/media/manageUsersMenuIcon.b7e5882d719d4b9ed39a65d490c7ed20.svg";
export { ForwardRef as ReactComponent };